import tw from 'tailwind-styled-components'
import DetailsCard from '../DetailsCard'

export const Card = tw(DetailsCard)`
  w-full
  max-w-sm
  m-auto
`
